import axios from 'axios';

import { Placa } from '@models/placa.model';

const lista = async (): Promise<Placa[]> => {
  const res = await axios.get<Placa[]>('/placas');
  return res.data;
};

export default {
  lista,
};
